import React from 'react'
import { useDispatch } from 'react-redux'
import { svgShape } from './operatorShape'
import * as actions from './actions'

const iconWidth = 40
const iconHeight = 30

export default ({ category, type, shape }) => {
  const dispatch = useDispatch()
  let handleClick = () => {
    dispatch(actions.addOperator(type))
  }
  return (
    <button className="operatorButton" onClick={handleClick}>
      <div className="iconContainer">
        {svgShape({ shape: shape, width: iconWidth, height: iconHeight })}
      </div>
      <label>{ type }</label>
    </button>
  )
}
